import React from 'react';
import { SearchProps } from '../../types/header.types';
import { SEARCH_PLACEHOLDER } from '../../constants/navigation.constants';

const SearchBar: React.FC<SearchProps> = ({ 
  placeholder = SEARCH_PLACEHOLDER,
  onSearch,
  value = '',
  onChange
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(value);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(value);
  };

  return (
    <div className="header__busca rounded">
      <form onSubmit={handleSubmit} action="/resultado-busca">
        <button type="submit" className="btn-busca">
          <img
            src={require('../../../../assets/img/lupa.svg').default}
            alt="Buscar"
            width="16"
            height="16"
            className="mr-1 ml-2"
          />
        </button>
        <input
          type="text"
          name="s"
          id="s"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyPress={handleKeyPress}
          required
        />
      </form>
    </div>
  );
};

export default SearchBar;